export default {"src":"/_next/static/media/headerPhotoIcon.2e74a943.svg","height":39,"width":40,"blurWidth":0,"blurHeight":0};